import React from 'react';

import MilestoneTeaser from './Teaser';
import MilestoneDetail from './Detail';

const TaxonomyMilestone = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <MilestoneTeaser {...props} />;
  }

  return <MilestoneDetail {...props} />;
};

export default TaxonomyMilestone;
